import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { verifyGuard } from './core/guards/verify.guard';
import { authGuard } from './core/guards/auth.guard';


export const routes: Routes = [
    { path: '', component: Home },
    {
        path: 'about',
        loadComponent: () => import('./pages/about-us/about-us').then(c => c.AboutUs)
    },
    {
        path: 'services-fees',
        loadComponent: () => import('./pages/services-fees/services-fees').then(c => c.ServicesFees)
    },
    {
        path: 'faqs',
        loadComponent: () => import('./pages/faqs/faqs').then(c => c.Faqs)
    },
    {
        path: 'contact-us',
        loadComponent: () => import('./pages/contact-us/contact-us').then(c => c.ContactUs)
    },
    {
        path: 'social-media-report',
        loadComponent: () => import('./pages/social-media-report/social-media-report').then(c => c.SocialMediaReport)
    },
    {
        path: 'social-juror-vetting',
        loadComponent: () => import('./pages/social-juror-vetting/social-juror-vetting').then(c => c.SocialJurorVetting)
    },
    {
        path: 'social-pre-visa',
        loadComponent: () => import('./pages/social-pre-visa/social-pre-visa').then(c => c.SocialPreVisa)
    },
    {
        path: 'social-bespoke',
        loadComponent: () => import('./pages/social-bespoke/social-bespoke').then(c => c.SocialBespoke)
    },
    {
        path: 'order-deep-report/:mode',
        loadComponent: () => import('./pages/order-deep-report/order-deep-report').then(c => c.OrderDeepReport),
        canActivate: [authGuard, verifyGuard]
    },
    {
        path: 'order-deep-report/:mode/:id',
        loadComponent: () => import('./pages/order-deep-report/order-deep-report').then(c => c.OrderDeepReport),
        canActivate: [authGuard, verifyGuard]
    },

    {
        path: 'order-juror-report/:mode',
        loadComponent: () => import('./pages/order-juror-report/order-juror-report').then(c => c.OrderJurorReport),
        canActivate: [authGuard, verifyGuard]
    },
    {
        path: 'order-juror-report/:mode/:id',
        loadComponent: () => import('./pages/order-juror-report/order-juror-report').then(c => c.OrderJurorReport),
        canActivate: [authGuard, verifyGuard]
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy').then(c => c.PrivacyPolicy)
    },
    {
        path: 'terms-of-use',
        loadComponent: () => import('./pages/terms-of-use/terms-of-use').then(c => c.TermsOfUse)
    },
    {
        path: 'cookies',
        loadComponent: () => import('./pages/cookies/cookies').then(c => c.Cookies)
    },
    {
        path: 'international-data-transfers',
        loadComponent: () => import('./pages/international-data-transfers/international-data-transfers').then(c => c.InternationalDataTransfers)
    },
    {
        path: 'checkout/success/:type',
        loadComponent: () => import('./shared/success/success').then(c => c.Success),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'checkout/additional/:id/:search',
        loadComponent: () => import('./pages/checkout/checkout').then(c => c.Checkout),
        canActivate: [authGuard, verifyGuard]
    },
    {
        path: 'checkout/:checkoutkey/:id',
        loadComponent: () => import('./pages/checkout/checkout').then(c => c.Checkout),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'login',
        loadComponent: () => import('./auth/login/login').then(c => c.Login)
    },
    {
        path: 'signup',
        loadComponent: () => import('./auth/signup/signup').then(c => c.Signup)
    },
    {
        path: 'verify',
        loadComponent: () => import('./auth/verify/verify').then(c => c.Verify),
        canActivate: [authGuard],
    },
    {
        path: 'request-reset-password',
        loadComponent: () => import('./auth/request-reset-password/request-reset-password').then(c => c.RequestResetPassword)
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./auth/reset-password/reset-password').then(c => c.ResetPassword)
    },
    {
        path: 'verify-2fa-backup-email/:id/:token',
        loadComponent: () => import('./auth/verify-2fa-backup-email/verify-2fa-backup-email').then(c => c.Verify2FABackupEmail)
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./auth/dashboard/dashboard').then(c => c.Dashboard),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'invoices',
        loadComponent: () =>
            import('./auth/invoices/invoices').then(c => c.Invoices),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'settings',
        loadComponent: () => import('./auth/settings/settings').then(c => c.Settings),
        canActivate: [authGuard, verifyGuard]
    },
    {
        path: '**',
        redirectTo: '/'
    }

];
